import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Section } from 'components/features/home-page/styles';
import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { MarketingTileSkeleton } from 'components/marketing-tile/marketing-tile.skeleton';
import { HeroSkeleton } from 'components/ucl/hero/hero.skeleton';
import { useContentCardsNotificationsExperiment } from 'experiments/use-content-cards-notifications';
import { spacing } from 'styles/constants';

export const HomePageSkeleton = React.memo(() => {
  // Treatment moves marketing cards to the notification inbox, so the home skeleton
  // must not show marketing tile placeholders that will never resolve here.
  const { isNewsFeedEnabled } = useContentCardsNotificationsExperiment();

  return (
    <ScrollView>
      <HeroSkeleton />
      {!isNewsFeedEnabled ? (
        <CenteredRowContainer standardPadding containerStyle={styles.cardsContainer}>
          <Section first last shouldRenderDefaultBackground>
            <MarketingTileSkeleton />
          </Section>
        </CenteredRowContainer>
      ) : null}
    </ScrollView>
  );
});

const styles = StyleSheet.create({
  cardsContainer: {
    marginTop: spacing.$4,
  },
});
